export enum REMOVE_ACTION_TYPES {
	REMOVE_PERISCOPE = 'remove_periscope'
}
